module.exports = __webpack_public_path__ + "static/media/edit.6e830bcf.svg";